import { render, staticRenderFns } from "./ListModules.vue?vue&type=template&id=323c2838&"
import script from "./ListModules.vue?vue&type=script&lang=js&"
export * from "./ListModules.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports